<template>
  <div id="GoBack" @click="GoBack()" v-if="isShowGoBack">
    <!-- <span class="glyphicon glyphicon-chevron-up"></span> -->
    <img class="" src="@/assets/img/goBack.png" alt="">
  </div>
</template>
<script>
// import $ from "jquery";
export default {
  name: "GoBack",
  data() {
    return {
      // flag: true
    };
  },
  computed: {
    isShowGoBack() {
      return this.$store.state.isShowGoBack;
    }
  },
  methods: {
    GoBack() {
      // 返回上一页
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
#GoBack {
  width: 70px;
  height: 70px;
  position: fixed;
  right: 20px;
  bottom: 90px;
  z-index: 99999999;
  cursor: pointer;
}
#GoBack > img {
  display: block;
  width: 100%;
  height: 100%;
  /* color: rgb(8, 162, 233); */
  /* color: #e90003;
  font-size: 30px; */
}
</style>



// WEBPACK FOOTER //
// src/components/GoBack.vue